import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormCandidateBlockDetailsPriceBreakdown from '../price/blocks/SoFormCandidateBlockDetailsPriceBreakdown';
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormPriceRange from './SoFormPriceRange';
import { selectors as settingsSelectors } from 'state/settings';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Disclaimer = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  text-align: justify;

  /* grey / 700 */

  color: #54708c;
  a {
    text-decoration: underline;
    color: var(--primary500);
    /* font-weight: 500; */
  }
`;

const SoFormPriceBreakdownSummary = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsState = useSoFormStepsState();
  const selectedProductType = stepsState.price.selectedProductType;
  const candidates = stepsState.price.candidates;
  const selectedCandidate = candidates.find(
    (c) => c.productType === selectedProductType
  );
  const quote = stepsState.activeQuote;

  const showPriceBreakdown = selectedCandidate.pricing_strategy === 'INSTANT';
  const showPriceRange = selectedCandidate.pricing_strategy === 'RFQ_RANGE';

  const transportLawLink =
    'https://www.ontruck.com/es/blog/real-decreto-nueva-ley-transporte';
  const termsAndConditionsLink =
    'https://www.ontruck.com/es/empresas/terminos-condiciones-cargadores';

  const countrySettings = useSelector(settingsSelectors.getCountrySettings);
  const isSpain = countrySettings.country === 'ES';

  const showDisclaimer = isSpain;
  return (
    <div className={className}>
      {showPriceBreakdown && (
        <SoFormCandidateBlockDetailsPriceBreakdown
          quote={quote}
          isSummary={true}
        />
      )}
      {showPriceRange && <SoFormPriceRange quote={quote} />}
      {showDisclaimer && (
        <Disclaimer>
          {t('confirmation.disclaimer_spain.line1')}{' '}
          <b>
            ({t('confirmation.disclaimer_spain.line2')}{' '}
            <a target="_blank" href={transportLawLink} rel="noreferrer">
              {t('confirmation.disclaimer_spain.line3')}
            </a>
            )
          </b>{' '}
          {t('confirmation.disclaimer_spain.line4')}
        </Disclaimer>
      )}
      <Disclaimer>
        {t('confirmation.disclaimer_terms.line1')}{' '}
        <b>
          <a target="_blank" href={termsAndConditionsLink} rel="noreferrer">
            {t('confirmation.disclaimer_terms.line2')}
          </a>
        </b>
      </Disclaimer>
    </div>
  );
};

SoFormPriceBreakdownSummary.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormPriceBreakdownSummary)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 0px;
  gap: 32px;
`;
